// COMPARISON SLIDER
document.addEventListener('DOMContentLoaded', function() {
  const comparisonSlider = document.querySelector('.c-slider-wrap.comparison .c-slider');
  if(comparisonSlider){
    var comparisonSwiper = new Swiper(comparisonSlider, {
      loop: true,
      slidesPerView: 1,
      speed: 500,
      spaceBetween: 24,
      navigation: {
        nextEl: '.c-slider-wrap.comparison .c-slider-arrow.next',
        prevEl: '.c-slider-wrap.comparison .c-slider-arrow.prev',
      },
    });
  }
});